/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_LabelInputs */

const es_settings_files_filters_label = /** @type {(inputs: Settings_Files_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtros`)
};

const en_settings_files_filters_label = /** @type {(inputs: Settings_Files_Filters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Settings_Files_Filters_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_label = /** @type {((inputs?: Settings_Files_Filters_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_label(inputs)
	return en_settings_files_filters_label(inputs)
});
export { settings_files_filters_label as "settings.files.filters.label" }